import { ConnectedProps, connect } from 'react-redux';
import { progressSelectorFactory } from 'src/common';
import { fetchRoles, selectPortfoliosWithoutAll, selectRoles } from 'src/features/clients/client/common/store';
import { selectBenchmarks } from 'src/features/clients/client/performance/store/selectors';
import { fetchBenchmarks } from 'src/features/clients/client/performance/store/thunks';
import { reportsMapDispatchToProps, reportsMapStateToProps } from 'src/features/clients/client/reportsV2/container';
import { ClientListActionTypes, fetchClientList } from 'src/features/clients/list/store/thunks';
import { RootState } from 'src/store';
import { selectHasClientDirectAccess, selectHasClientEditAdminOnly, selectIsDataFromTriumph } from 'src/store/selectors';
import { selectBulkReporting, selectReportingReports } from '../store/selectors';
import { reportingSlice } from '../store/slice';
import { ReportingActionTypes, fetchFilteredReportClients, validateClientIds } from '../store/thunks';
import { CreateScheduledReportComponent } from './components/CreateScheduledReportComponent';
import { EditScheduledReportComponent } from './components/EditScheduledReportComponent';
import { selectScheduler } from './store/selectors';
import { schedulerSlice } from './store/slice';
import {
  SchedulerActionTypes,
  createScheduledEvent,
  fetchAfslTemplates,
  fetchPracticeTemplates,
  fetchScheduledEventById,
  triggerScheduledEvent,
  updateScheduledEvent,
} from './store/thunks';

const mapStateToProps = (state: RootState) => ({
  ...reportsMapStateToProps(state),
  reports: selectReportingReports(state),
  scheduler: selectScheduler(state),
  benchmarks: selectBenchmarks(state),
  bulk: selectBulkReporting(state),
  roles: selectRoles(state),
  clientPortfolios: selectPortfoliosWithoutAll(state),
  isDataFromTriumph: selectIsDataFromTriumph(state),
  hasClientEditAdminOnlyPermission: selectHasClientEditAdminOnly(state),
  hasClientDirectAccess: selectHasClientDirectAccess(state),
  clientListProgress: progressSelectorFactory([ClientListActionTypes.FetchClientList])(state),
  createScheduledEventProgress: progressSelectorFactory([SchedulerActionTypes.CreateScheduledEvent])(state),
  fetchScheduledEventByIdProgress: progressSelectorFactory([SchedulerActionTypes.GetScheduledEventById])(state),
  updateScheduledEventProgress: progressSelectorFactory([SchedulerActionTypes.UpdateScheduledEvent])(state),
  triggerScheduledEventProgress: progressSelectorFactory([SchedulerActionTypes.TriggerScheduledEvent])(state),
  fetchAfslTemplatesProgress: progressSelectorFactory([SchedulerActionTypes.AfslTemplates])(state),
  fetchPracticeTemplatesProgress: progressSelectorFactory([SchedulerActionTypes.PracticeTemplates])(state),
  fetchFilteredReportClientsProgress: progressSelectorFactory([ReportingActionTypes.GetFilteredReportClients])(state),
  validateClientIdsProgress: progressSelectorFactory([ReportingActionTypes.ValidateClientIds])(state),
});

const mapDispatchToProps = {
  ...schedulerSlice.actions,
  ...reportingSlice.actions,
  ...reportsMapDispatchToProps,
  fetchClientList,
  fetchBenchmarks,
  createScheduledEvent,
  triggerScheduledEvent,
  fetchScheduledEventById,
  fetchFilteredReportClients,
  updateScheduledEvent,
  fetchAfslTemplates,
  fetchPracticeTemplates,
  fetchRoles,
  validateClientIds,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;

export const EditScheduledReportContainer = connector(EditScheduledReportComponent);
export const CreateScheduledReportContainer = connector(CreateScheduledReportComponent);
